import { MAX_ATTACHMENT_IMAGE_SIZE } from '@lumapps/medias/constants';
import { MediaSource } from '@lumapps/medias/types';
import { getMediaUrl, isMediaURLFromLumdrive, makeSecuredMediaURLRelative } from '@lumapps/medias/utils';
import { resizeLumdriveImage } from '@lumapps/medias/utils/resizeImage';

import { MediaPreview } from '../../../types';

export const getImageUrl = (image: Partial<MediaPreview>, isThumbnail?: boolean, isResizingEnabled?: boolean) => {
    if ((image.source === MediaSource.HAUSSMANN_MEDIA || image.isSecure) && image.mediaId) {
        // Cap thumbnails so clients don't download multi-MB originals through the permalink (SO-2697).
        const size = isThumbnail && isResizingEnabled ? MAX_ATTACHMENT_IMAGE_SIZE : undefined;
        return getMediaUrl(image.mediaId, size);
    }
    if (isThumbnail) {
        const url = makeSecuredMediaURLRelative(image.thumbnail?.url || image.url) || '';
        // Lumdrive `/serve/` images are capped through the legacy `=s{size}` suffix.
        return isResizingEnabled && isMediaURLFromLumdrive(url)
            ? resizeLumdriveImage(url, MAX_ATTACHMENT_IMAGE_SIZE)
            : url;
    }
    return makeSecuredMediaURLRelative(image.url);
};

/**
 * Make sure the alt won't be the fileName
 * @param image
 * @returns an alt for the image
 */
export const getImageAlt = (image: Partial<MediaPreview>): string => {
    const { fileName, description, title } = image;
    if (description !== fileName) {
        return description || '';
    }
    if (title !== fileName) {
        return title || '';
    }
    return '';
};
